import React from 'react';
import { Reveal } from './Reveal';
type PageHeaderProps = {
  label: string;
  title: string;
  intro: React.ReactNode;
  image?: {
    src: string;
    alt: string;
  };
  actions?: React.ReactNode;
};
export function PageHeader({
  label,
  title,
  intro,
  image,
  actions
}: PageHeaderProps) {
  return <section className="border-b border-ink/10 bg-mist" data-id="element-229" data-mp="3mezlt54wdqgh">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 py-14 sm:py-20 lg:grid-cols-12 lg:gap-12 lg:px-10 lg:py-24" data-id="element-230" data-mp="3mdg2t6rux1b0">
        <Reveal className={image ? 'lg:col-span-7' : 'lg:col-span-9'} data-id="element-231" data-mp="2tr3ru86pqcne">
          <div className="flex items-center gap-3 sm:gap-4" data-id="element-232" data-mp="2tor238upqxzs">
            <span className="h-px w-8 bg-gold sm:w-12" aria-hidden="true" data-id="element-233" data-mp="38gjfhfay61yv" />
            <p className="text-sm font-medium text-gold-dark" data-id="element-234" data-mp="33ohxrdv0fj1g">{label}</p>
          </div>
          <h1 className="mt-5 font-serif text-[36px] font-medium leading-[1.06] tracking-tight text-navy sm:mt-6 sm:text-5xl lg:text-[58px]" data-id="element-235" data-mp="2fz738e496kvr">
            {title}
          </h1>
          <div className="mt-6 max-w-2xl text-[16px] leading-7 text-ink/75 sm:text-lg sm:leading-relaxed" data-id="element-236" data-mp="2ayjb1p4afxzy">
            {intro}
          </div>
          {actions && <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-237" data-mp="2lz8vri0t25vh">{actions}</div>}
        </Reveal>

        {image && <Reveal delay={0.08} className="relative lg:col-span-5" data-id="element-238" data-mp="2qs1zq3og9a6i">
            <div className="absolute -bottom-4 -right-4 hidden h-full w-full border border-gold/70 sm:block" aria-hidden="true" data-id="element-239" data-mp="2vpbln9cmr3pl" />
            <img src={image.src} alt={image.alt} className="relative aspect-[5/4] w-full object-cover" data-id="element-240" data-mp="231fs2dicxrx1" />
          </Reveal>}
      </div>
    </section>;
}